import Bezier from "bezier-js";

export default class SplineWalker {

    set playing(value) {
        this._playing = value;
    }

    get playing() {
        return this._playing;
    }

    get position() {
        return this._walker.clone();
    }

    get currentAngle() {
        return this._currentAngle;
    }

    set speed(value) {
        this._speed = value;
    }

    /**
     * @param data
     * @param scale
     */
    constructor(data, scale = 1) {

        this._data = data;

        this._t = 0;
        this._speed = 0.25;
        this._playing = false;

        this._beziers = [];
        this._currentBezierIndex = 0;

        // start at zero by offsetting from first point
        const offset = new PIXI.Point(this._data[0].point1.x * scale, this._data[0].point1.y * scale);

        for (let i = 0; i < this._data.length; i++) {
            const d = this._data[i];

            const bezier = new Bezier(
                d.point1.x * scale - offset.x, d.point1.y * scale - offset.y,
                d.controlPoint.x * scale - offset.x, d.controlPoint.y * scale - offset.y,
                d.point2.x * scale - offset.x, d.point2.y * scale - offset.y);

            this._beziers.push(bezier);
        }

        this._walker = new P3.math.Vector2(this._data[0].point1.x * scale - offset.x, this._data[0].point1.y * scale - offset.y); // start at first point

        const d = this._beziers[this._currentBezierIndex].derivative(this._t);
        const norm = new P3.math.Vector2(d.x, d.y).normalize();

        this._currentAngle = Math.atan2(norm.y, norm.x);

    }

    update(dt) {

        if (!this._playing)
            return;

        if (this._t > 1) {
            // move to next bezier
            this._t = 0;
            this._currentBezierIndex++;
        }

        if (this._beziers[this._currentBezierIndex]) {
            const p = this._beziers[this._currentBezierIndex].get(this._t);
            this._walker.set(p.x, p.y);

            const d = this._beziers[this._currentBezierIndex].derivative(this._t);
            const norm = new P3.math.Vector2(d.x, d.y).normalize();

            this._currentAngle = Math.atan2(norm.y, norm.x);

          //  console.log(this._currentAngle);

        } else {
            this._playing = false;
        }

        this._t += this._speed * dt;

    }
}